<template>
  <el-dialog
          :title="'查看附件'"
          :close-on-click-modal="false"
          :visible.sync="visible"
          style="text-align: center">
    <el-row>
      <el-button type="primary" @click="preview()">预览附件</el-button>
      <el-button type="primary" @click="download()">下载附件</el-button>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {

    data () {
      return {
        contract:'',
        visible:false
      }
    },
    methods: {
      init (row) {
        this.contract = row
        this.visible = true
        this.$nextTick(() => {

        })

      },
      preview(){
        if(this.contract) {
          if(!this.contract.attach) {
            this.$message.error("暂无附件")
            return
          }

          var viewUrl = this.$request.defaults.baseURL+'/bjba/equip/realcontract/preview/'+this.contract.id+'?access_token='+this.$store.getters.token
          window.open(viewUrl)
        }
      }
      ,  download(){
        if(this.contract) {
          if(!this.contract.attach) {
            this.$message.error("暂无附件")
            return
          }

          var viewUrl = this.$request.defaults.baseURL+'/bjba/equip/realcontract/download/'+this.contract.id+'?access_token='+this.$store.getters.token
          window.open(viewUrl)
        }
      }
    }
  }
</script>
